import { gql } from '@apollo/client';

export const TASK_ASSIGNED_SUBSCRIPTION = gql`
    subscription {
        onAssignedTask {
            id
            name
        }
    }
`;

export const PROCESS_ASSIGNED_SUBSCRIPTION = gql`
    subscription {
        onAssignedProcess {
            id
            name
            description
        }
    }
`;

export const LAST_USED_APPS_SUBSCRIPTION = gql`
    subscription lastUsedProcesses($id: String) {
        onEntityChange(type: "user", id: $id) {
            primary(fields: ["lastUsedProcesses"])
        }
    }
`;

export const ENTITY_CHANGE_SUBSCRIPTION = gql`
    subscription entityChange($type: String!, $id: ID!) {
        onEntityChange(type: $type, id: $id) {
            id
            primary(fields: ["closedDate"])
            modifiedBy{
                id
            }
        }
    }
`;

export const TASK_CHANGE_SUBSCRIPTION = gql`
    subscription taskChange($type: String!, $id: ID!) {
        onEntityChange(type: $type, id: $id) {
            id
            name
            primary(fields: ["closedDate", "priority", "progress", "startDate", "dueDate", "assignee"])
            modifiedBy {
                id
                name
            }
        }
    }
`;

export const PROCESS_CHANGE_SUBSCRIPTION = gql`
    subscription processChange($type: String!, $id: ID!) {
        onEntityChange(type: $type, id: $id) {
            id
            primary(fields: ["closedDate", "priority", "assignee"])
            modifiedBy {
                id
                name
            }
        }
    }
`;

export const CLASS_CHANGE_SUBSCRIPTION = gql`
    subscription classChange($type: String!, $id: ID!) {
        onEntityChange(type: $type, id: $id) {
            id
            attributes
            modifiedBy {
                id
                name
            }
        }
    }
`;

// Covers process variables AND media for the task form surface. Both ride on the same
// onEntityChange selection so a single subscription delivers either change, keeping toast
// + state-sync in one handler (TaskFormTab.onProcessVariablesChange).
export const PROCESS_VARIABLES_CHANGE_SUBSCRIPTION = gql`
    subscription processVariablesChange($type: String!, $id: ID!) {
        onEntityChange(type: $type, id: $id) {
            id
            primary
            media {
                mediaName
                fileId
                fileName
                fileSize
                mimeType
                uploadedBy {
                    type
                    id
                    name
                    image
                    username
                    active
                }
                uploadedDate
                etag
            }
            modifiedBy {
                id
                name
            }
        }
    }
`;
